import React, { useEffect } from "react";
import Hero from '../elements/Hero';
import JunkBanner from '../img/junk_banner1.jpg';
import Title from "../elements/Title";
import Btn from "../elements/Btn";
import Footer from "../elements/Footer";
import RemovalServices from "../elements/RemovalServices";
import packvideo from '../img/packvideo.png';
import movie from '../video/movie.mp4';
import { Link } from "react-router-dom";
import LearnArrow from '../img/color_arrow.png';
import Checklist from "../elements/Checklist";
import s3 from '../img/junkremoval_items.png';
import PackagePlan from "../elements/PackagePlan";
import AdditionalServices from "../elements/AdditionalServices";
import HappyCustomers from "../elements/HappyCustomers";
import QuickServices from "../elements/QuickServices";
import FreeQuote from "../elements/FreeQuote";
import Newsletter from "../elements/Newsletter";
import user from '../img/testimonial.png';


export default function JunkRemoval() {

    const removalService = [
        {
            title: "Appliance Recycling", 
            des: "Exquisite Moves is the preferred service provider for appliance recycling and environmentally friendly appliance removal and disposal in the nation! No need to lift a finger because we do all the work. "
        },
        {
            title: "Furniture Removal",
            des: "Whether you need to get rid of a single chair or an entire house full of old furniture, Exquisite Moves is here to provide you with the quick, efficient, and eco-friendly furniture removal services you need."
        },
        {
            title: "Basement Cleanout",
            des: "Exquisite Moves is the stress-free solution for all your basement cleanout and cleanup needs. Whether you’ve got outdated exercise equipment, heavy furniture, old appliances, televisions."
        },
        {
            title: "Comprehensive Moving Checklist",
            des: "How many steps are there to moving? The more you think about it, the more steps there seem to be. When you hire the HUNKS, you'll also receive a comprehensive moving checklist to help with your big move."
        }
    ]

    const customers = [
        {
        title: "Excellent service, on time. Careful, courteous!",
        description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
        user: "Dianne Russell",
        userPost: "Exquisitemoves Director",
        useravatar: user,
        rating: "4.9"
        },
        {
        title: "Excellent service, on time. Careful, courteous!",
        description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
        user: "Dianne Russell",
        userPost: "Exquisitemoves Director",
        useravatar: user,
        rating: "4.9"
        },
        {
        title: "Excellent service, on time. Careful, courteous!",
        description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
        user: "Dianne Russell",
        userPost: "Exquisitemoves Director",
        useravatar: user,
        rating: "4.9"
        },
        {
        title: "Excellent service, on time. Careful, courteous!",
        description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
        user: "Dianne Russell",
        userPost: "Exquisitemoves Director",
        useravatar: user,
        rating: "4.9"
        },
        {
        title: "Excellent service, on time. Careful, courteous!",
        description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
        user: "Dianne Russell",
        userPost: "Exquisitemoves Director",
        useravatar: user,
        rating: "4.9"
        }, 

    ]


  return(
    <>
      <Hero bg={JunkBanner} clsName="junkbanner_sec">
        <div className='pt-3 pt-sm-4 pt-lg-5 bannerTri junk_banner' >
                <div className='row' >
                    <div className='col-md-12 pb-5 mt-3' >
                        <div className='banner_content py-0 pt-4' >
                            <Title mainClass="text-center"
                                titleclass="lg text-white mb-2"
                                desclass="text-center mt-3 mb-3 mb-sm-5"
                                title={<>Eco-Friendly Junk Removal <br/> Services</>}
                                des="Declutter Your Life with the Help of ExquisiteMoves which is the nation’s leading full-service moving company, offering customers comprehensive home and business relocation, packing and unpacking, and junk removal services."/>
                            <Btn class="mb-4 m-auto d-table"
                                arrow={true}
                                wave={true} 
                                href="#"
                            >Book now Junk Removal Service</Btn>
                        </div>
                    </div>
                </div>
            </div>
      </Hero>

      <RemovalServices />
 
      <div className='delivaryAffordable py-3 py-sm-5' >
            <div className='container' >
                <Title mainClass="mb-3"
                    subheading="Exquisite Moves Junk Removal Prices"
                    subclass="border-none text-center text-uppercase"
                    titleclass="md heading text-dark text-center  mb-3 mt-0 mt-lg-3"
                    desclass="mb-0 text-center w-50 m-auto d-table"
                    title={<>Delivering Affordable & Convenient <br /> Disposal Solutions</>}
                    des="No two jobs are the same and our teams take pride in offering honest and transparent pricing for your junk removal needs. At the start of each job, our team will provide a free, no obligation estimate based on the volume your junk items take up in our truck."
                />
                <div className="removal_btnbox mb-3 mb-md-0">
                  <div className="removal_btns mb-0 mb-md-3 pb-0 pb-md-3">
                    <Link to="/">Furniture Removal</Link>
                    <Link to="/">Cleanout Services</Link>
                    <Link to="/">Grage Cleaning</Link>
                  </div>
                  <Link to="/" className="learn_more">Learn More <img src={LearnArrow} alt="arrow" /></Link>
                </div>
                <div className='pcVid' >
                    <video poster={packvideo} controls >
                        <source src={movie} type="video/mp4" />
                        <source src={movie} type="video/ogg" />
                    </video>
                </div>
            </div>
        </div>

      <div className="bg_wrapper mt-0 mt-lg-5">
        <div className="container">
          <div className="serviceSec pt-5 pb-5" >
                    <div className="row " >
                        <div className="col-lg-6" >
                            <Title mainClass="mb-3"
                                subheading="tems We Take"
                                subclass="border-none text-start"
                                titleclass="lg heading text-dark text-start mb-3"
                                desclass="mb-0"
                                title={<>Junk Removal Items <br/> We Take</>}
                                des="Reclaim Your Space with the Help of Exquisite Moves!"
                            />
                            <div className="space my-4 orange" ></div>
                            <h3><strong>What Junk Items Can We Take?</strong></h3>
                            <Checklist 
                                list={["Furniture", "Office Equipment", "Carpeting", "Trash Removal", "Mattresses and Box Springs", "Exercise Equipment & More Items"]}
                                class="mt-3 mt-lg-4 mb-0 mb-lg-5 text-dark" 
                                col="col-sm-6" 
                                liststyle="rounded"  /> 
                            <Btn class="mt-5 mt-md-0"
                                arrow={true}
                                wave={true}
                                wavedark={true}
                                href="#"
                            >Book now Junk Removal Service</Btn>
                        </div>
                        <div className="col-lg-6 pt-3 pt-lg-0 ps-lg-5" >
                            <img src={s3} className="img-fluid" alt="services" />
                        </div>
                    </div>
                </div> 
        </div>
        <div class="packages junkremove_package py-3 py-sm-4 py-lg-5 my-lg-5 ">
            <div class="container">
                <div className='packagingTitle mb-5 pb-3'>
                    <div className='row  justify-content-between align-items-center'>
                        <div className='col-sm-6'>
                            <Title mainClass=" d-block"
                                titleclass="lg text-dark text-center text-md-start mb-2"
                                desclass="mb-0 text-md-start text-center"
                                title={<>Book Our Eco-Friendly Junk <br/> Removal Services</>}
                                />
                        </div>
                        <div class="col-sm-6">
                            <Btn class="position-relative mt-4 m-auto  m-md-0 mt-md-4 m-lg-auto d-table"
                                arrow={true}
                                wave={true}
                                wavedark={true}
                                href="#"
                            > Book now Junk Removal Service</Btn>
                        </div>
                    </div>
                    </div>
                    <PackagePlan />
                </div>
        </div>
      </div>

      <AdditionalServices  title="Additional Services"
        des="Whether You’re Looking For A Little Help Loading And Unloading Your Moving Truck, Or You Want A Full-Service Move Including Packing, Unpacking, Arranging, And Everything In Between, Our Team Is Ready To Help You. We Promise To Provide 100% Satisfaction With Every Project."
         data={removalService} />
      <HappyCustomers customers={customers} /> 
      <QuickServices />
      <FreeQuote />
      <Newsletter />
      <Footer />
    </>
  )
}
